/* Admin Modals */
import ShowFurniture from 'Components/Modal/ShowFurniture';
import SentOrder from 'Components/Modal/SentOrder';
import CreateProduct from 'Components/Modal/CreateProduct';
import CreateFurniture from 'Components/Modal/CreateFurniture';
import AddNote from 'Components/Modal/AddNote';
import DefaultModal from 'Components/Modal/DefaultModal';

const ModalWrapper = ({ modal }) => (
	<div id="modal">
		{(() => {
			switch (modal.name) {
				case 'showFurniture':
					return <ShowFurniture params={modal.params} />;
				case 'sentOrder':
					return <SentOrder params={modal.params} />;
				case 'createFurniture':
					return <CreateFurniture params={modal.params} />;
				case 'createProduct':
					return <CreateProduct />;
				case 'addNote':
					return <AddNote params={modal.params} />;
				case 'default':
				default:
					return <DefaultModal params={modal.params} />;
			}
		})()}
	</div>
);

ModalWrapper.propTypes = {
	modal: PropTypes.shape({
		name: PropTypes.string.isRequired,
		params: PropTypes.instanceOf(Object)
	})
};

ModalWrapper.defaultProps = {
	modal: {
		params: null
	}
};

export default ModalWrapper;
